import Soultan121 from "./Soultan 12 (1).png";
import Soultan122 from "./Soultan 12 (2).png";
import Soultan123 from "./Soultan 12 (3).png";
import Soultan151 from "../Soultan15/soultan15 (1).png";
import Soultan152 from "../Soultan15/soultan15 (2).png";
import Soultan153 from "../Soultan15/soultan15 (3).png";
import Soultan154 from "../Soultan15/soultan15 (4).png";
import Soultan155 from "../Soultan15/soultan15 (5).png";
import Soultan156 from "../Soultan15/soultan15 (6).png";
import Soultan157 from "../Soultan15/soultan15 (7).png";
import Soultan158 from "../Soultan15/soultan15 (8).png";
import Soultan159 from "../Soultan15/soultan15 (9).png";
import Soultan1510 from "../Soultan15/soultan15 (10).png";
import Soultan1511 from "../Soultan15/soultan15 (11).png";
import Soultan1512 from "../Soultan15/soultan15 (12).png";
import Soultan1513 from "../Soultan15/soultan15 (13).png";
import Soultan1514 from "../Soultan15/soultan15 (14).png";
import Soultan1515 from "../Soultan15/soultan15 (15).png";
import Soultan1516 from "./Soultan 15 (2).png";
import Soultan1517 from "./Soultan 15 (3).png";
import Soultan181 from "./Soultan 18 (1).png";
import Soultan182 from "./Soultan 18 (2).png";
import Soultan183 from "./Soultan 18 (3).png";

const Soultan12 = [Soultan121, Soultan122, Soultan123];
const Soultan15 = [
  Soultan151,
  Soultan152,
  Soultan153,
  Soultan154,
  Soultan155,
  Soultan156,
  Soultan157,
  Soultan158,
  Soultan159,
  Soultan1510,
  Soultan1511,
  Soultan1512,
  Soultan1513,
  Soultan1514,
  Soultan1515,
  Soultan1516,
  Soultan1517,
];
const Soultan18 = [Soultan181, Soultan182, Soultan183];

export { Soultan12, Soultan15, Soultan18 };
